export default "__VITE_ASSET__36b8b2de__$_?component__"